'use es6';

import { Style } from 'reporting-visualizations/visualizations/xy/xyRecords';
import { mapLayerCategories } from 'reporting-visualizations/visualizations/xy/xyLayers';
import { List, Map as ImmutableMap } from 'immutable';
import { configureDateLine } from 'reporting-ui-components/reports/decorators/ConfigOptionsDecorator/dateLine';
import { fromJS } from '../../../lib/jsUtils';
export const applyIncludeDateLine = (visualization, report) => {
  const includeDateLine = report.getIn(['displayParams', 'includeDateLine'], ImmutableMap());
  if (!includeDateLine.has('key') && !includeDateLine.has('date')) {
    return visualization;
  }
  const firstLayer = visualization.get('layers').find(layer => layer.get('dataset') !== 'compare');
  if (!firstLayer) {
    return visualization;
  }
  const categories = mapLayerCategories(firstLayer.set('dataset', visualization.getIn(['data', firstLayer.get('dataset')])), 'x').toJS().map(category => ImmutableMap(category));
  const datelineInfo = configureDateLine(includeDateLine, categories);

  // Only update visualization if datelineInfo exists
  return datelineInfo ? visualization.update('style', (style = Style({})) => style.setIn(['x', 'bottom', 'rules', 'plotLines'], List([fromJS(datelineInfo)]))) : visualization;
};